<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 lg6 v-for="(list, i) in lists" :key="i">
        <request-list :title="list.title" :create="list.create" :items="list.items"
                      @view="goToList(list.view)"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex';
  import RequestList from './DashboardList';
  import mapStatus from './mapStatus';

  export default {
    components: { RequestList },
    data() {
      return {
        lists: [
          { title: 'Pending requests', create: '/approvals/request', view: 'pending', items: [] },
          { title: 'Waiting for my approval', view: 'awaiting', items: [] },
          { title: 'Past requests', view: 'closed', items: [] }
        ]
      };
    },
    computed: mapState('auth', [
      'user'
    ]),
    methods: {
      summarizeApprovers(approvers) {
        let names = approvers[0];
        if (approvers.length > 1) {
          names += ', ' + approvers[1];
        }
        if (approvers.length > 2) {
          names += '...';
        }

        return names;
      },
      getData(params) {
        return this.$services.authenticator.get('/approvals/requests', {
          params: {
            ...params,
            size: 5
          }
        });
      },
      goToList(view) {
        const location = {
          name: 'ApprovalRequestList',
          params: { status: 'PENDING' },
          query: { userId: this.user.sub, userType: 'user' }
        };
        if (view === 'awaiting') {
          location.query.userType = 'approver';
        } else if (view === 'closed') {
          location.params.status = 'APPROVED,REJECTED,CANCELLED';
        }

        this.$router.push(location);
      }
    },
    mounted() {
      this.getData({ user: this.user.sub, status: 'PENDING' })
        .then((response) => this.lists[0].items = response.data.data.map((r) => ({
          scopes: r.summary,
          user: this.summarizeApprovers(r.approvers.map((u) => u.name)),
          userId: r.user.aoid,
          createdTs: r.createdTs
        }))).catch(this.$defaultHandlerHttp);
      this.getData({ approver: this.user.sub, status: 'PENDING' })
        .then((response) => this.lists[1].items = response.data.data.map((r) => ({
          scopes: r.summary,
          user: r.user.name,
          userId: r.user.aoid,
          createdTs: r.createdTs
        }))).catch(this.$defaultHandlerHttp);
      this.getData({ user: this.user.sub, status: 'APPROVED,REJECTED,CANCELLED' })
        .then((response) => this.lists[2].items = response.data.data.map((r) => ({
          scopes: r.summary,
          user: r.closedBy.name,
          status: mapStatus(r.status),
          userId: r.user.aoid,
          createdTs: r.createdTs
        }))).catch(this.$defaultHandlerHttp);
    }
  };
</script>

<style scoped>

</style>
